import { render, staticRenderFns } from "./ManagedAcademyGroups.vue?vue&type=template&id=a8ce30c0"
import script from "./ManagedAcademyGroups.vue?vue&type=script&lang=js"
export * from "./ManagedAcademyGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports